import type { PayloadAction } from '@reduxjs/toolkit';
import type { MedNecCaseSliceState } from '../state';

export const filterReducers = {
  setStatusFilter: (state: MedNecCaseSliceState, action: PayloadAction<string | null>) => {
    state.filters.status = action.payload;
  },

  setFacilityFilter: (state: MedNecCaseSliceState, action: PayloadAction<string | null>) => {
    state.filters.facility = action.payload;
  },

  clearFilters: (state: MedNecCaseSliceState) => {
    state.filters = { status: null, facility: null };
  },
};
